// AUTO-GENERATED: 2025-10-28T19:10:34.720706Z
// 🍲 Indonesian recipes

export const indonesianRecipes = [
{
    name: "Nasi Goreng",
    cuisine: "Indonesian",
    ingredients: ["rice", "chicken", "eggs", "cabbage", "scallions"],
    sauces: ["kecap manis", "sambal", "shrimp paste", "garlic"],
    instructions: "Use day-old rice. Heat wok, fry scrambled eggs, remove. Add shrimp paste and garlic, stir-fry until fragrant. Add chicken, cook through. Add rice, breaking up clumps. Stir-fry 5 minutes. Add kecap manis, sambal, vegetables. Toss well. Garnish with fried shallots, scallions, and egg. Serve with prawn crackers and cucumber.",
    time: "20 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Mie Goreng",
    cuisine: "Indonesian",
    ingredients: ["noodles", "chicken", "cabbage", "carrots", "bean sprouts", "eggs"],
    sauces: ["kecap manis", "sambal", "oyster sauce", "garlic"],
    instructions: "Cook noodles, drain. Heat wok, scramble eggs, remove. Stir-fry chicken until cooked. Add garlic, vegetables. Stir-fry 3 minutes. Add noodles, kecap manis, sambal, oyster sauce. Toss everything together 2-3 minutes. Add eggs back in. Garnish with fried shallots and scallions. Serve with lime wedges and extra sambal.",
    time: "25 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Rendang",
    cuisine: "Indonesian",
    ingredients: ["beef", "coconut milk", "lemongrass", "galangal", "kaffir lime leaves", "ginger", "garlic"],
    sauces: ["rendang paste", "tamarind paste", "palm sugar"],
    instructions: "Blend rendang paste with lemongrass, galangal, ginger, garlic. Simmer beef with paste and coconut milk. Add tamarind and palm sugar. Cook on low heat 3-4 hours, stirring occasionally, until sauce is very thick and oil separates. Beef should be tender and dark. Garnish with fried shallots. Serve with rice.",
    time: "240 min",
    difficulty: "Hard",
    points: 150,
    servings: 2,
    special: true
  },
{
    name: "Satay",
    cuisine: "Indonesian",
    ingredients: ["chicken thighs", "lemongrass", "garlic", "shallots"],
    sauces: ["kecap manis", "peanut sauce", "lime juice", "sambal"],
    instructions: "Marinate chicken chunks in kecap manis, garlic, shallots for 2+ hours. Thread onto bamboo skewers. Grill over high heat, turning frequently, until charred and cooked through. Make peanut sauce: blend peanuts, chilies, garlic, palm sugar, tamarind, coconut milk. Serve satay with peanut sauce, rice cakes, cucumber, and onion.",
    time: "30 min + marinade",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Gado-Gado",
    cuisine: "Indonesian",
    ingredients: ["cabbage", "bean sprouts", "green beans", "potatoes", "eggs", "tofu", "tempeh"],
    sauces: ["peanut sauce", "kecap manis", "lime juice", "sambal"],
    instructions: "Blanch vegetables separately. Boil eggs, halve. Fry tofu and tempeh until golden. Make peanut sauce: blend peanuts, chilies, garlic, palm sugar, tamarind, water. Arrange vegetables, eggs, tofu, tempeh on plate. Pour warm peanut sauce over everything. Top with prawn crackers and fried shallots. Serve at room temperature.",
    time: "35 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Soto Ayam",
    cuisine: "Indonesian",
    ingredients: ["chicken", "vermicelli noodles", "bean sprouts", "eggs", "cabbage", "potato"],
    sauces: ["turmeric", "lemongrass", "galangal", "lime juice", "fried shallots"],
    instructions: "Simmer chicken with turmeric, lemongrass, galangal until tender. Remove chicken, shred. Strain broth. Cook vermicelli, boil eggs. Assemble bowls: noodles, shredded chicken, bean sprouts, sliced egg, cabbage. Ladle hot broth over. Garnish with fried shallots, celery leaves. Serve with lime wedges, sambal, and rice.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Ayam Goreng",
    cuisine: "Indonesian",
    ingredients: ["chicken pieces", "garlic", "ginger", "galangal", "lemongrass"],
    sauces: ["coriander", "turmeric", "coconut milk", "lime leaves"],
    instructions: "Blend garlic, ginger, galangal, coriander, turmeric to paste. Marinate chicken with paste and coconut milk for 2+ hours. Simmer chicken in marinade with lemongrass and lime leaves until tender and liquid evaporates, about 30 minutes. Deep fry chicken until golden and crispy. Serve with rice, sambal, and fresh vegetables.",
    time: "60 min + marinade",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Nasi Kuning",
    cuisine: "Indonesian",
    ingredients: ["rice", "coconut milk", "turmeric", "lemongrass", "bay leaves", "pandan leaves"],
    sauces: ["fried shallots", "sambal"],
    instructions: "Rinse rice. Cook with coconut milk, turmeric, lemongrass, bay leaves, pandan leaves, and salt. Fluff when done. Serve on large platter shaped into cone (tumpeng). Arrange side dishes around rice: fried chicken, beef rendang, perkedel, eggs, vegetables. Garnish with fried shallots. Serve for special occasions.",
    time: "40 min",
    difficulty: "Easy",
    points: 50,
    servings: 2
  },
{
    name: "Bakso",
    cuisine: "Indonesian",
    ingredients: ["beef meatballs", "noodles", "bok choy", "fried wontons", "tofu"],
    sauces: ["beef broth", "garlic", "soy sauce", "fried shallots", "sambal"],
    instructions: "Simmer beef broth with garlic. Form ground beef mixed with tapioca starch into meatballs. Poach in broth until cooked through. Cook noodles. Blanch bok choy. Fry wontons and tofu. Assemble bowls: noodles, meatballs, vegetables, fried wontons, tofu. Ladle hot broth over. Garnish with fried shallots, celery leaves. Serve with sambal and lime.",
    time: "45 min",
    difficulty: "Medium",
    points: 75,
    servings: 2
  },
{
    name: "Martabak",
    cuisine: "Indonesian",
    ingredients: ["ground beef", "eggs", "scallions", "flour", "curry leaves"],
    sauces: ["curry powder", "garlic", "sweet soy sauce", "cucumber pickle"],
    instructions: "Make filling: brown ground beef with curry powder, garlic, scallions. Make dough with flour, eggs, water. Rest 30 minutes. Roll very thin. Place filling on half, fold and seal edges. Pan-fry in oil until golden and crispy on both sides. Cut into squares. Serve hot with cucumber pickle and sweet soy sauce for dipping.",
    time: "60 min",
    difficulty: "Hard",
    points: 100,
    servings: 2
  }
];
